import React from 'react';
import PropTypes from 'prop-types';
import Bar from './Bar';
import { Diagram as Styled } from './styles'
import Title from '../../Symbols/Title';
import WithMore from '../WithMore';

function Diagram({
	title,
	items = [],
	getValue,
	renderValue
}) {
	if (!items.length) {
		return null;
	}

	const max = getValue(items[0]);

	return <Styled>
		<Title>{title}</Title>

		{items.map((item, index) => <Bar key={index} {...item} max={max} getValue={getValue} renderValue={renderValue} />)}

	</Styled>
}

Diagram.propTypes = {
	title: PropTypes.string.isRequired,
	items: PropTypes.arrayOf(PropTypes.object).isRequired,
	opened: PropTypes.bool,
	getValue: PropTypes.func.isRequired,
	renderValue: PropTypes.func
}

export default WithMore(Diagram, { length: 7 })
